import React from 'react'
import { Drawer } from 'antd'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ placement, onClose, open, children, ...otherProps }) => {
  return <Drawer
    placement={placement}
    closable={false}
    className={classNames(styles['mn-drawer'])}
    {...otherProps}
  >
    {children}
  </Drawer>
}
